import React from 'react';

import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';
import { Theme, Button, CircularProgress } from '@mui/material';
import Refresh from '@mui/icons-material/Refresh';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            padding: theme.spacing(1),
        },
    }),
);

interface Props {
    onClick?: () => void;
    isRefreshing?: boolean;
}

const RefreshButton: React.FunctionComponent<Props> = ({
    onClick,
    isRefreshing,
}) => {
    const classes = useStyles();

    return (
        <Button
            variant="outlined"
            className={classes.root}
            onClick={onClick}
            disabled={isRefreshing}
        >
            {isRefreshing ? <CircularProgress size={24} /> : <Refresh />}
        </Button>
    );
};

RefreshButton.displayName = 'RefreshButton';
export default RefreshButton;
